import React from "react";
import { useState } from "react";
import { Row, Col, Container, Badge, Button } from "react-bootstrap";

export default function CategorieProposte(props) {

    // Valore temporaneo nell'input
    let [value, setValue] = useState("")

    // Controlla se la categoria è già presente
    let isInList = category => {
        return props.categorie.includes(category);
    }

    // Si occupa della gestione della pressione del tasto invio, virgola o tab
    let handleKeyDown = evt => {
        if (["Enter", "Tab", ","].includes(evt.key)) {
            evt.preventDefault();
            var val = value.trim();
            if (val && !isInList(val)) {
                props.setCategorie(old => [...old, val])
                setValue("")
            }
        }
    }

    // Gestione della scrittura di una nuova categoria
    let handleChange = evt => {
        setValue(evt.target.value)
    }

    // Eliminazione della categoria
    let handleDelete = item => {
        props.setCategorie(old => old.filter(el => el !== item))
    }

    return (
        <>
            <input className="w-100"
                value={value}
                placeholder="Scrivi la categoria che desideri inserire e premi `Invio`"
                onKeyDown={handleKeyDown}
                onChange={handleChange}
            />

            <Row className="p-0 mt-2">
                {props.categorie && props.categorie.map((item, index) => (
                    <Col className="d-flex justify-content-center mb-1 " key={index} md={12} >
                        <Badge key={index} pill bg="light" className="w-100 d-flex justify-content-between badge-categorie">
                            <Container fluid="xs" className="my-auto">
                                {item}
                            </Container>
                            <Button variant="light"
                                onClick={() => handleDelete(item)}>
                                &times;
                            </Button>
                        </Badge>
                    </Col>
                ))}
            </Row>
        </>
    )
}

